import {
  landing_page_continue_to_signin,
  landing_page_viewed,
  redirected_after_load_on_land,
} from '@onramp/utils/eventing/eventDeclarations';
import { logEvent } from '@onramp/utils/eventing/logEvent';
import { AnalyticsEventImportance } from '@cbhq/client-analytics';

/** Login-wall view — uses wrapped logEvent so appId attaches via getDefaultMetadata. */
export function logLandingPageViewed(redirectUrl: string | undefined) {
  logEvent('onramp.landing_page_viewed', landing_page_viewed(redirectUrl), {
    importance: AnalyticsEventImportance.high,
  });
}

export function logLandingContinueToSignin() {
  logEvent('onramp.landing_page_continue_to_signin', landing_page_continue_to_signin, {
    importance: AnalyticsEventImportance.high,
  });
}

export function logRedirectedAfterLoadOnLand() {
  logEvent(
    'onramp.redirected_after_load_on_land',
    {
      ...redirected_after_load_on_land,
      isGuestCheckoutEligible: false,
    },
    { importance: AnalyticsEventImportance.high },
  );
}
